import { render, staticRenderFns } from "./RichTextObjectMenu.vue?vue&type=template&id=5b692653&"
import script from "./RichTextObjectMenu.vue?vue&type=script&lang=ts&"
export * from "./RichTextObjectMenu.vue?vue&type=script&lang=ts&"
import style0 from "./RichTextObjectMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports